const userActionConstants = {
  GET_USER_LOGIN: "GET_USER_LOGIN",
  REGISTER_NEW_USER: "REGISTER_NEW_USER",
};

export default userActionConstants;
